import Autocomplete from '../vendors/search/autocomplete';
const search = () => {
  const autocompleteForms = document.querySelectorAll('.search-from');
  autocompleteForms.forEach($form => {
    const autocompleteInstance = new Autocomplete({
      selector: $form
    });

    // Handle form reset logic
    $form.addEventListener('reset', () => {
      setTimeout(() => {
        const input = $form.querySelector('input[name="tx_solr[q]"]');
        if (input) {
          // Clear the input value completely
          input.value = '';

          // Reset the autocomplete instance
          if (typeof autocompleteInstance.reset === 'function') {
            autocompleteInstance.reset();
          }
        }
      }, 0); // Delay to ensure it runs after the default reset behavior
    });
  });
};
export default search;